import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth/AuthContext.tsx';
import { App } from './App.tsx';
import { AdminPage } from './components/AdminPage.tsx';
import '@resolution-processing/balance/styles.css';
import './i18n.ts';
import './index.css';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: 'production',
    release: import.meta.env.VITE_COMMIT_SHA || 'dev',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

// Route to the admin page at /admin (not linked from the main UI).
// The server serves index.html for all paths via SPA fallback; routing is
// determined here by pathname, matching the manual window.location pattern
// used throughout the rest of the app.
const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdmin ? (
      // AdminPage calls GET /admin/companies on mount; server returns 401/403
      // if the session is missing or not admin — authorization is server-authoritative.
      // AuthProvider is not needed here since AdminPage drives auth via the API response.
      <AdminPage />
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </StrictMode>,
);
